import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './SearchAutoCorrectContainer';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import styles from './search_auto_correct.module.scss';

const Link: FC<React.HTMLProps<HTMLAnchorElement>> = (props) => (
  <a className={styles.link} {...props} /> // eslint-disable-line jsx-a11y/anchor-has-content
);

type Props = PropsFromRedux;

export class RawSearchAutoCorrect extends React.Component<Props> {
  onForceSearchCorrectedClicked = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const { onCorrectQuery, autoCorrectedQuery } = this.props;
    doctrineAnalytics('Search ZeroResultCorrectedQueryClicked');

    if (!event.metaKey && !event.ctrlKey && event.nativeEvent.which !== 2) {
      event.preventDefault();
      onCorrectQuery(autoCorrectedQuery);
    }
  };

  onForceSearchTypoClicked = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const { onForceTypo } = this.props;

    doctrineAnalytics('Search ZeroResultQueryClicked');

    if (!event.metaKey && !event.ctrlKey && event.nativeEvent.which !== 2) {
      event.preventDefault();
      onForceTypo();
    }
  };

  render() {
    const { correctedUrl, typoUrl, query, highlightedWords } = this.props;
    return (
      <div className={styles.container}>
        <span className={styles.correctedQuery}>
          <span className={styles.title}>
            <FormattedMessage id="search/components/auto-correct/SearchAutoCorrect.tsx/1" />{' '}
          </span>
          <Link
            href={correctedUrl}
            onClick={this.onForceSearchCorrectedClicked}
          >
            {highlightedWords.map((word: typeof highlightedWords[0]) => (
              <React.Fragment key={word.key}>
                {!word.same && <b className={styles.edited}>{word.text}</b>}
                {word.same && <span>{word.text}</span>}
              </React.Fragment>
            ))}
          </Link>
        </span>
        <div className={styles.originalQuery}>
          <span className={styles.originalQueryTitle}>
            <FormattedMessage id="search/components/auto-correct/SearchAutoCorrect.tsx/2" />{' '}
          </span>
          <Link href={typoUrl} onClick={this.onForceSearchTypoClicked}>
            {query}
          </Link>
        </div>
      </div>
    );
  }
}
export const SearchAutoCorrect = Connect(RawSearchAutoCorrect);
